import { Item } from './Item'

export function List({ data, params }) {
    return (
        <>
            {data.map((item, index) => (
                <Item key={index} data={item} odd={index % 2 === 0} params={params} />
            ))}
        </>
    )
}
